module.exports = __webpack_public_path__ + "img/mobile-categories.73faa688.webp";